import React from "react";
import { Icon } from "../../Common/Icons/LucideIcons";
import { FloatingIconButton } from "./__styles__/ChatToggleButton";

export interface ChatToggleButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({
  onClick,
  isOpen = false,
}) => {
  return (
    <FloatingIconButton
      type="button"
      onClick={onClick}
      aria-label={isOpen ? "Close AI Assistant" : "Open AI Assistant"}
    >
      <Icon iconName="sparkles" color="contentPrimaryInverted" size={16} />
    </FloatingIconButton>
  );
};

export default ChatToggleButton;
